<!-- State: Trust Dropdown -->
<ng-container *ngIf="currentState === 'trust-dropdown'">
  <div class="input-beneficiary-card__type-section">
    <p class="c11n-text-md-bold">{{ content.BENEFICIARY_TRUST }}</p>
    <a
      *ngIf="showChangeType"
      c11n-link
      href="javascript:void(0)"
      [variant]="'primary-reinforced'"
      [iconName]="'edit'"
      [iconPosition]="'leading'"
      (click)="changeType.emit()"
    >
      {{ content.BENEFICIARY_CHANGE }}
    </a>
  </div>

  <div class="input-beneficiary-card__content-section">
    <div class="input-beneficiary-card__trust-dropdown">
      <c11n-dropdown
        [labelText]="content.BENEFICIARY_TRUST_DROPDOWN_LABEL"
        [placeholderText]="content.BENEFICIARY_TRUST_DROPDOWN_PLACEHOLDER"
        [menuData]="trustDropdownData"
        [activeItems]="existingData?.householdMemberId ? [existingData!.householdMemberId!] : []"
        (stateChange)="handleTrustDropdownChange($event)"
      ></c11n-dropdown>
      <c11n-hint-error
        *ngIf="showTrustSelectError"
        [hasError]="true"
        [size]="'medium'"
        [errorText]="content.BENEFICIARY_TRUST_SELECT_ERROR"
        hintErrorId="bene-trust-select-error"
      ></c11n-hint-error>
    </div>
  </div>

  <div *ngIf="mode === 'edit'" class="input-beneficiary-card__cancel-section">
    <button
      c11n-link
      [variant]="'secondary-reinforced'"
      class="input-beneficiary-card__cancel-link"
      (click)="cancel.emit()"
    >
      {{ content.BENEFICIARY_CANCEL }}
    </button>
  </div>
</ng-container>

<!-- State: Trust Inline Form (Add new trust / Edit existing trust) -->
<ng-container *ngIf="currentState === 'trust-inline-form'">
  <div class="input-beneficiary-card__type-section">
    <p class="c11n-text-md-bold">{{ content.BENEFICIARY_TRUST }}</p>
    <a
      *ngIf="showChangeType"
      c11n-link
      href="javascript:void(0)"
      [variant]="'primary-reinforced'"
      [iconName]="'edit'"
      [iconPosition]="'leading'"
      (click)="changeType.emit()"
    >
      {{ content.BENEFICIARY_CHANGE }}
    </a>
  </div>

  <div class="input-beneficiary-card__content-section">
    <!-- Trust dropdown showing "+ Add new trust" selected -->
    <div class="input-beneficiary-card__trust-dropdown">
      <c11n-dropdown
        [labelText]="content.BENEFICIARY_TRUST_DROPDOWN_LABEL"
        [placeholderText]="content.BENEFICIARY_TRUST_DROPDOWN_PLACEHOLDER"
        [menuData]="trustDropdownData"
        [activeItems]="['ADD_NEW_TRUST']"
        (stateChange)="handleTrustDropdownChange($event)"
      ></c11n-dropdown>
    </div>

    <p class="c11n-text-md">{{ content.BENEFICIARY_TRUST_FORM_ALL_FIELDS_REQUIRED }}</p>

    <!-- Row 1: Settlor + Trust type (dropdowns) -->
    <div class="input-beneficiary-card__form-row">
      <div class="input-beneficiary-card__form-field">
        <c11n-dropdown
          [labelText]="content.BENEFICIARY_TRUST_SETTLOR_LABEL"
          [placeholderText]="'Select one'"
          [menuData]="settlorOptions"
          [activeItems]="trustSettlor ? [trustSettlor] : []"
          (stateChange)="handleTrustSettlorChange($event)"
        ></c11n-dropdown>
        <c11n-hint-error
          [hasError]="!validTrustSettlor"
          [size]="'medium'"
          [errorText]="content.BENEFICIARY_FIELD_REQUIRED_ERROR"
          [hintText]="validTrustSettlor ? content.BENEFICIARY_TRUST_SETTLOR_HINT : ''"
          hintErrorId="bene-trust-settlor-error"
        ></c11n-hint-error>
      </div>

      <div class="input-beneficiary-card__form-field">
        <c11n-dropdown
          [labelText]="content.BENEFICIARY_TRUST_TYPE_LABEL"
          [placeholderText]="'Select one'"
          [menuData]="trustTypeOptions"
          [activeItems]="trustType ? [trustType] : []"
          (stateChange)="handleTrustTypeChange($event)"
        ></c11n-dropdown>
        <c11n-hint-error
          [hasError]="!validTrustType"
          [size]="'medium'"
          [errorText]="content.BENEFICIARY_FIELD_REQUIRED_ERROR"
          hintErrorId="bene-trust-type-error"
        ></c11n-hint-error>
      </div>
    </div>

    <!-- Row 2: Display name (optional) + Legal trust name (inputs) -->
    <div class="input-beneficiary-card__form-row">
      <div class="input-beneficiary-card__form-field">
        <label c11n-label for="bene-trust-display-name" [size]="'medium'">{{
          content.BENEFICIARY_TRUST_DISPLAY_NAME_LABEL
        }}</label>
        <c11n-input [size]="'medium'">
          <input
            c11nInput
            [(ngModel)]="trustDisplayName"
            id="bene-trust-display-name"
            type="text"
            placeholder="Trust display name"
          />
        </c11n-input>
        <c11n-hint-error
          [hasError]="false"
          [size]="'medium'"
          [hintText]="content.BENEFICIARY_TRUST_DISPLAY_NAME_HINT"
          hintErrorId="bene-trust-display-name-hint"
        ></c11n-hint-error>
      </div>

      <div class="input-beneficiary-card__form-field">
        <label c11n-label for="bene-trust-legal-name" [size]="'medium'">{{
          content.BENEFICIARY_TRUST_LEGAL_NAME_LABEL
        }}</label>
        <c11n-input [size]="'medium'">
          <input
            c11nInput
            [(ngModel)]="trustLegalName"
            id="bene-trust-legal-name"
            type="text"
            [placeholder]="content.BENEFICIARY_TRUST_LEGAL_NAME_LABEL"
            (ngModelChange)="validateTrustLegalName()"
            (blur)="validateTrustLegalName()"
          />
        </c11n-input>
        <c11n-hint-error
          [hasError]="!validTrustLegalName"
          [size]="'medium'"
          [errorText]="content.BENEFICIARY_FIELD_REQUIRED_ERROR"
          [hintText]="validTrustLegalName ? content.BENEFICIARY_TRUST_LEGAL_NAME_HINT : ''"
          hintErrorId="bene-trust-legal-name-error"
        ></c11n-hint-error>
      </div>
    </div>

    <!-- Save / Cancel actions -->
    <div class="input-beneficiary-card__save-section">
      <c11n-button
        *ngIf="!isSaving"
        [variant]="'secondary'"
        [size]="'medium'"
        [labelText]="content.BENEFICIARY_TRUST_SAVE_BUTTON"
        (clickEvent)="handleTrustSave()"
      ></c11n-button>
      <c11n-button
        *ngIf="isSaving"
        [variant]="'secondary'"
        [size]="'medium'"
        [labelText]="'Saving...'"
      ></c11n-button>
      <button
        c11n-link
        [variant]="'secondary-reinforced'"
        class="input-beneficiary-card__cancel-link"
        (click)="cancel.emit()"
      >
        {{ content.BENEFICIARY_CANCEL }}
      </button>
    </div>
  </div>
</ng-container>
